export default {
	"39a8c193b3b84def79a278b709e94f2b": "未获取到unionId",
	"ac70c15430eff1f21a7baaa5e188ca9e": "跳转中...",
	"0675de48149f684874f7629cace17ff8": "请求失败，请联系客服"
}
